import { CmsComponentTypeEnum } from '@models/enums/cms-component-type.enum';
import { LinkObject, TImageConfig,TextMediaBox } from '@models/interfaces';
import { BaseComponentConfig } from '@interfaces/config/cms-components/base-config';
import { DocumentReference } from '@interfaces/documents';

export namespace HeroSlider {
  export const TypeEnum = CmsComponentTypeEnum.HERO_SLIDER;

  export interface SlideConfig {
    headline: string;
    subHeadline: string;
    imageConfig: TImageConfig;
    gradientOverlay?: string;
    link?: LinkObject;
    reference?: DocumentReference;
    media:  TextMediaBox.MediaVideoConfig | TextMediaBox.MediaYoutubeVideoConfig | TextMediaBox.MediaAudioConfig;

  }

  export interface NewsConfig {
    uri: LinkObject;
  
    newsTitle:string
  }




  export interface ComponentConfig extends BaseComponentConfig {
    slides: SlideConfig[];
    newsItems :NewsConfig[],
    isNewsTicker:boolean;
    field_news_ticker_position?:string;
  }

  export const MAX_LENGTHS = {
    HEADLINE: 32,
    SUB_HEADLINE: 160,
  };
}
